// 账号与充值模块

//获取账号信息
function accountInformation() {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetAccountInfo" },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取账号信息出错");
            resolve(false);
          }
        } else {
          console.log("获取账号信息出错");
          resolve(false);
        }
      }
    });
  });
}

//保存账号信息
function saveAccountInformation(infor) {
  return new Promise(resolve => {
    $.ajax({
      url: APIEnt,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "accountinfo", accountInfo: JSON.stringify(infor) },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("保存账号信息出错");
            resolve(false);
          }
        } else {
          console.log("保存账号信息出错");
          resolve(false);
        }
      }
    });
  });
}

//企业生成账号
function createCompanyAccount(accountInfo) {
  const { username, usertel, useremail, userid_e = "", entid } = accountInfo;
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), action: "save", pagename: "initentacct", username, usertel, useremail, userid_e, entid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("企业生成账号出错");
            resolve(false);
          }
        } else {
          console.log("企业生成账号出错");
          resolve(false);
        }
      }
    });
  });
}

//查询企业剩余点数
function leftoverPoints(entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bgetentcoininfo", entid },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? str.msg : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//充值
function topUpCompany(entid, topUp) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "baddconfforcoin", entid, jsonstr: JSON.stringify(topUp) },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

export default {
  accountInformation,
  saveAccountInformation,
  createCompanyAccount,
  leftoverPoints,
  topUpCompany
};
